export default function doLog( key: string, ext?: string,  type = 'CLK'){
  const {goldlog} = window as any;
  if (goldlog) {
      goldlog.record(key, type, ext);
  }
}